<template>
  <div>
    <v-dialog v-model="value" persistent fullscreen>
      <v-card height="100%" color="black" @click="loadCamera">
        <vue-web-cam
          v-if="value == true"
          ref="wc"
          :deviceId="deviceId"
          style="position: absolute"
          :width="width"
          :height="height"
        ></vue-web-cam>
        <!-- :selectFirstDevice="true" -->
        <div style="position: relative; top: 1%; left: 2%; width: 300px">
          <v-layout>
            <v-btn icon dark @click="$emit('input', false)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-select
              :items="devices"
              label="Cam"
              dark
              item-text="label"
              item-value="deviceId"
              class="ml-10"
              v-model="deviceId"
            >
            </v-select>
          </v-layout>
        </div>
        <v-btn
          style="position: relative; top: 50%; left: 50%; opacity: 0.5"
          fab
          color="success"
          @click="snapShot"
        >
          <v-icon>mdi-camera</v-icon>
        </v-btn>

        <!-- :selectFirstDevice="true" -->
        <!-- <div class="row pl-10 pr-10 pb-2">
          <v-btn color="primary" fab x-large dark @click="$emit('input',false)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn color="success" fab x-large dark @click="snapShot">
            <v-icon>mdi-camera</v-icon>
          </v-btn>
        </div>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isArray } from "xstate/lib/utils";
export default {
  props: ["value"],
  data() {
    return {
      devices: [],
      device: null,
      firstDeviceId: null,
      deviceId: null,
      width: null,
      height: null,
    };
  },
  watch: {
    async devices(v) {
      if (v && v.length > 0) {
        this.deviceId = v[0].deviceId;
        await this.loadCamera();
      }
    },
    async deviceId(v) {
      if (v != null) {
        await this.loadCamera();
      }
    },
    value() {
      if (this.value == true) {
        this.$nextTick(() => {
          this.getDevice();
          //this.loadCamera();
        });
      }
    },
  },
  methods: {
    async loadCamera() {
      if (this.$refs.wc) {
        await this.$refs.wc.loadCamera(this.deviceId);
        await this.$forceUpdate();
      }
    },
    async getDevices() {
      return navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
        return deviceInfos.filter((di) => di.kind == "videoinput");
      });
    },
    async getDevice() {
      let device = await navigator.mediaDevices.enumerateDevices().then((devices) => {
        devices = devices.filter((v) => v.kind == "videoinput");
        console.log("Found " + devices.length + " video devices");

        let lastDevice = devices[devices.length - 1];
        devices = devices.filter((v) => v.label.indexOf("back") > 0);

        let device = null;
        if (devices.length > 0) {
          console.log("Taking a 'back' camera");
          device = devices[devices.length - 1];
        } else {
          console.log("Taking last camera");
          device = lastDevice;
        }

        if (!device) {
          console.log("No devices!");
          return;
        }
        return device;
      });

      this.device = device;
    },
    async getFirstDeviceId() {
      let devices = await this.getDevices();
      if (isArray(devices)) return devices[0].deviceId;
      else return devices.deviceId;
    },
    async snapShot() {
      let file = await this.urltoFile(this.$refs.wc.capture(), "photo.jpg", "image/jpeg");

      this.$emit("snapshot", file);
      this.$emit("input", false);
    },
    async getPermissionCamera() {
      let permission = await navigator.permissions.query({ name: "camera" });
      if (permission.state == "granted") return;
      await navigator.mediaDevices.getUserMedia({ audio: false, video: true });
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
  },

  async mounted() {
    await this.getPermissionCamera();
    this.$nextTick(() => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    });
    this.devices = await this.getDevices();
  },
};
</script>
